import styled from 'styled-components';
import { Typography } from 'design-system/src/components/Typography/Typography';

export const SIDEBAR_BORDER_COLOR = 'var(--grayscale-50)';

export const Sidebar = styled.div<{ $isCollapsed?: boolean }>`
  display: ${({ $isCollapsed }) => ($isCollapsed ? 'none' : 'flex')};
  align-self: stretch;
  flex-direction: column;
  font-size: 0.875rem;
  font-style: normal;
  line-height: 133.333%;
  // NOTE: the sidebar was shifting in size when we were only using 'width'
  min-width: 19.75rem;
  max-width: 19.75rem;
  border-left: 1px solid ${SIDEBAR_BORDER_COLOR};

  > div:last-child {
    border-bottom: none;
  }
`;

export const SidebarSection = styled.div`
  border-bottom: 1px solid var(--grayscale-50);
  padding: 16px 20px;
  display: flex;
  gap: 12px;
  flex-direction: column;
`;

export const SidebarHeader = styled.div`
  color: var(--grayscale-900);
  font-weight: 590;
  margin-bottom: 0.5rem;
`;

export const SidebarRow = styled.div`
  display: flex;
  flex-direction: row;
  font-weight: 400;
`;

export const SidebarRowLabel = styled.div`
  color: var(--grayscale-600);
  font-weight: 400;
  flex: 1;
`;

export const SidebarRowData = styled.div`
  color: var(--grayscale-900);
  flex: 1;
`;

export const StyledSidebarTopBar = styled.div`
  border-bottom: 1px solid var(--grayscale-50);
  height: var(--item-view-top-nav-height);
  box-sizing: border-box;
  padding: 1rem 1.5rem;
`;

export const SidebarTopBar = () => {
  return (
    <StyledSidebarTopBar>
      <Typography styledAs="bodySmallSpaceGrotesk" renderedAs="h2" weight={500}>
        Prescription Details
      </Typography>
    </StyledSidebarTopBar>
  );
};
